var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownPercentageMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ArrowDownPercentageMini") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.76 6.12h.01c.41.88.26 1.93-.38 2.67l-5.51 6.35c-.47.55-1.16.86-1.88.86s-1.41-.31-1.88-.86L.61 8.79c-.63-.73-.79-1.78-.38-2.67.41-.89 1.3-1.46 2.27-1.46H3V2.5C3 1.12 4.11 0 5.49 0h5.01c1.37 0 2.49 1.12 2.49 2.5v2.16h.5c.97 0 1.87.57 2.27 1.46zm-1.9 1.36h-.03c.28-.32.05-.82-.37-.82h-2.01a.5.5 0 01-.49-.5V2.49c0-.28-.22-.5-.49-.5H5.46a.5.5 0 00-.49.5v3.67c0 .28-.22.5-.49.5H2.47c-.42 0-.65.5-.37.82l5.51 6.35c.1.11.24.17.37.17s.27-.06.37-.17l5.51-6.35zM8.95 5.22c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-3 3c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 010-1.06l3-3zM8.7 7.97c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06-.29.29-.77.29-1.06 0a.754.754 0 010-1.06zM7.26 6.53c-.29.29-.77.29-1.06 0a.754.754 0 010-1.06c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownPercentageMini);
export default __webpack_public_path__ + "static/media/ArrowDownPercentageMini.f31341c86132532fdc8d545e9875a174.svg";
export { ForwardRef as ReactComponent };